/**
 * Display-Bootstrap (Fast-First-Paint) fuer die Anmeldeanzeige.
 *
 * Laeuft so frueh wie moeglich (vor dem ~1 MB Monolithen):
 *  - Skeleton der Kursanzeige sofort rendern
 *  - iframe-Hoehe frueh melden (Safari)
 *  - Firestore Prefetch + echte Offer-Karten (early paint)
 *  - Style-Tokens des Vereins sofort setzen
 *
 * Monolith ersetzt Early-Karten spaeter via renderOfferCards (Shell erkennt
 * data-vivlico-early-offers und loescht sie nicht vorher).
 */
import { isEditorPreviewHref, resolveDisplayRoute } from './urlParse.js';
import { renderDisplaySkeleton } from './skeleton.js';
import { startDisplayHeightSync, stopDisplayHeightSync } from './heightSync.js';
import { prefetchRegistrationData } from './dataLoader.js';
import { applyRegistrationStyleTokens } from './styleTokens.js';
import { renderEarlyOfferCards } from './earlyCards.js';

async function bootDisplay(): Promise<void> {
    let route;
    try {
        route = resolveDisplayRoute();
    } catch {
        return;
    }
    if (!route || !route.isOfferFamily || !route.clubRegId) return;

    // Preview-/Editor-Kontext dem Monolithen ueberlassen (Sonderfaelle).
    if (route.variant === 'preview' || isEditorPreviewHref()) {
        // Cache-Waermen bringt hier nichts Verlaessliches -> nur Skeleton.
    }

    try {
        renderDisplaySkeleton(route);
        startDisplayHeightSync();
    } catch {
        /* Skeleton ist best-effort */
    }

    try {
        const result = await prefetchRegistrationData(route);
        if (result.style) {
            applyRegistrationStyleTokens(result.style);
        }
        if (result.appointments.length > 0) {
            const painted = renderEarlyOfferCards(route, result.appointments);
            if (painted) {
                // Hoehe einmal nach Early-Paint; Monolith uebernimmt danach.
                try {
                    const main = document.getElementById('mainContent');
                    const height = Math.max(
                        main ? Math.max(main.scrollHeight, main.offsetHeight) : 0,
                        400,
                    );
                    if (window.parent !== window) {
                        window.parent.postMessage({ action: 'iframeHeight', iframeHeight: height }, '*');
                    }
                } catch {
                    /* ignore */
                }
            }
        }
    } catch {
        /* Prefetch ist best-effort */
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { void bootDisplay(); }, { once: true });
} else {
    void bootDisplay();
}

// Re-export stop for tests / explicit teardown
export { stopDisplayHeightSync };
